// Curated sports list for league/tournament management
// Only includes sports where leagues and tournaments are commonly organized
// Icons reference Tabler icon names (without 'Icon' prefix)
export const SPORTS_LIST = [
  // Popular Sports - shown first
  { id: 'basketball', name: 'Basketball', category: 'Popular', teamBased: true, icon: 'BallBasketball' },
  { id: 'soccer', name: 'Soccer', category: 'Popular', teamBased: true, icon: 'BallFootball' },
  { id: 'football', name: 'Football', category: 'Popular', teamBased: true, icon: 'BallAmericanFootball' },
  { id: 'volleyball', name: 'Volleyball', category: 'Popular', teamBased: true, icon: 'BallVolleyball' },
  { id: 'tennis', name: 'Tennis', category: 'Popular', teamBased: false, icon: 'BallTennis' },
  { id: 'pickleball', name: 'Pickleball', category: 'Popular', teamBased: false, icon: 'BallTennis' },

  // Ball Sports - Team
  { id: 'baseball', name: 'Baseball', category: 'Ball Sports', teamBased: true, icon: 'BallBaseball' },
  { id: 'softball', name: 'Softball', category: 'Ball Sports', teamBased: true, icon: 'BallBaseball' },
  { id: 'ultimate-frisbee', name: 'Ultimate Frisbee', category: 'Ball Sports', teamBased: true, icon: 'Trophy' },
  { id: 'dodgeball', name: 'Dodgeball', category: 'Ball Sports', teamBased: true, icon: 'Trophy' },
  { id: 'kickball', name: 'Kickball', category: 'Ball Sports', teamBased: true, icon: 'BallFootball' },

  // Racket Sports - Individual/Doubles
  { id: 'badminton', name: 'Badminton', category: 'Racket Sports', teamBased: false, icon: 'BallTennis' },
  { id: 'table-tennis', name: 'Table Tennis', category: 'Racket Sports', teamBased: false, icon: 'BallTennis' },
  { id: 'squash', name: 'Squash', category: 'Racket Sports', teamBased: false, icon: 'BallTennis' },
  { id: 'racquetball', name: 'Racquetball', category: 'Racket Sports', teamBased: false, icon: 'BallTennis' },
  { id: 'padel', name: 'Padel', category: 'Racket Sports', teamBased: false, icon: 'BallTennis' },

  // Ice/Field Sports - Team
  { id: 'hockey', name: 'Ice Hockey', category: 'Ice Sports', teamBased: true, icon: 'Trophy' },
  { id: 'field-hockey', name: 'Field Hockey', category: 'Field Sports', teamBased: true, icon: 'Trophy' },
  { id: 'lacrosse', name: 'Lacrosse', category: 'Field Sports', teamBased: true, icon: 'Trophy' },

  // Combat Sports - Individual Tournaments
  { id: 'boxing', name: 'Boxing', category: 'Combat Sports', teamBased: false, icon: 'Karate' },
  { id: 'mma', name: 'MMA', category: 'Combat Sports', teamBased: false, icon: 'Karate' },
  { id: 'wrestling', name: 'Wrestling', category: 'Combat Sports', teamBased: false, icon: 'Users' },
  { id: 'judo', name: 'Judo', category: 'Combat Sports', teamBased: false, icon: 'Karate' },
  { id: 'karate', name: 'Karate', category: 'Combat Sports', teamBased: false, icon: 'Karate' },
  { id: 'taekwondo', name: 'Taekwondo', category: 'Combat Sports', teamBased: false, icon: 'Karate' },

  // Competitive Individual Sports
  { id: 'golf', name: 'Golf', category: 'Individual Sports', teamBased: false, icon: 'Golf' },
  { id: 'bowling', name: 'Bowling', category: 'Individual Sports', teamBased: false, icon: 'BallBowling' },
  { id: 'cornhole', name: 'Cornhole', category: 'Precision Sports', teamBased: false, icon: 'TargetArrow' },
  { id: 'darts', name: 'Darts', category: 'Precision Sports', teamBased: false, icon: 'TargetArrow' },

  // Esports
  { id: 'esports', name: 'Esports', category: 'Esports', teamBased: true, icon: 'DeviceGamepad2' },

  // Other - for anything not listed
  { id: 'other', name: 'Other', category: 'Other', teamBased: false, icon: 'Dots' },
];

// Competition format types (for leagues and tournaments)
export const LEAGUE_FORMATS = {
  STANDARD_LEAGUE: {
    id: 'standard-league',
    name: 'Standard League',
    description: 'Regular season where everyone plays each other, followed by playoffs for top teams.',
    minParticipants: 4,
    requiresPowerOf2: false,
    type: 'league'
  },
  SINGLE_ELIMINATION: {
    id: 'single-elimination',
    name: 'Single Elimination Tournament',
    description: 'One loss and you\'re out. Winner advances, loser is eliminated.',
    minParticipants: 4,
    requiresPowerOf2: true,
    type: 'tournament'
  },
  DOUBLE_ELIMINATION: {
    id: 'double-elimination',
    name: 'Double Elimination Tournament',
    description: 'Two chances. Losers bracket gives eliminated players a second opportunity.',
    minParticipants: 4,
    requiresPowerOf2: false,
    type: 'tournament'
  },
  ROUND_ROBIN: {
    id: 'round-robin',
    name: 'Round Robin',
    description: 'Everyone plays everyone. Most wins at the end determines the champion.',
    minParticipants: 3,
    requiresPowerOf2: false,
    type: 'league'
  },
  SWISS: {
    id: 'swiss',
    name: 'Swiss System',
    description: 'Players with similar records face each other. No elimination.',
    minParticipants: 4,
    requiresPowerOf2: false,
    type: 'tournament'
  }
};

// League/Tournament status types
export const LEAGUE_STATUS = {
  DRAFT: 'draft',
  REGISTRATION: 'registration',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  ARCHIVED: 'archived' // Pauses billing, preserves data, can be reactivated
};

// League/Tournament visibility types (invite-only/request to join)
export const LEAGUE_VISIBILITY = {
  INVITE_ONLY: 'invite_only'
};

// Member roles
export const LEAGUE_ROLES = {
  ADMIN: 'admin',
  CAPTAIN: 'captain',
  PLAYER: 'player'
};

// Match status
export const MATCH_STATUS = {
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  FORFEIT: 'forfeit'
};

export default SPORTS_LIST;
